import Model from './Model'

export default class FS extends Model {
  resource() {
    return 'files'
  }
}
